import React, {useEffect, useState} from 'react';
import fieldService from '../../services/field-service';
import DangerBox from '../../libs/react-components-admin/box/danger-box';
import SelectField from '../../libs/react-components-admin/fields/select-field';

const EmailFieldIds = ({form, value, onChange}) => {

  const emailFields = (form.fields || []).filter(f => f.fieldType === 'EMAIL');
  const [model, setModel] = useState(value && value.length > 0 ?
    value :
    (emailFields.length > 0 ? [emailFields[0].id] : [])
  );

  useEffect(() => { onChange(model); }, [model]);

  return <>
    {emailFields.length === 0 &&
      <DangerBox>
        <span className="material-icons align-bottom">warning</span> The form &quot;{form.name || ''}&quot; does not contain any
        field of type &apos;Email&apos;.
      </DangerBox>
    }
    <SelectField label="Email field"
                 id="emailFieldId"
                 helpBlock="An email will be sent to the email address entered in this field"
                 value={model.length > 0 ? model[0] : ''}
                 onChange={id => setModel([id])}
                 values={emailFields.map(f => ({
                   label: fieldService.fieldDescription(f),
                   value: f.id,
                 }))}/>
  </>;
};

export default EmailFieldIds;
